var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import './index.scss';
import SwiperCore, { Virtual, Navigation } from 'swiper';
// import CarouselArrow from './CarouselArrow';
import { HoverListWithTab } from '../HoverListWithTabs/HoverList';
SwiperCore.use([Virtual, Navigation]);
import '../../lib/styles/swiper.scss';
import { useWindowSize } from '../../hooks/useWindowSize';
var defaultProps = {};
export var TwoCards = function (data) {
    // console.log(data.data);
    var _a = useState(0), scrolledBy = _a[0], setScrolledBy = _a[1];
    var navigationPrevRef = useRef(null);
    var navigationNextRef = useRef(null);
    var _b = useState(0), listNumber = _b[0], updateListNumber = _b[1];
    var _c = useState(0), scrollLeft = _c[0], updateScrollLeft = _c[1];
    var _d = useState(0), activeIndex = _d[0], updateActiveIndex = _d[1];
    var _e = useState(0), activeScrollPosition = _e[0], updateActiveScrollPosition = _e[1];
    var _f = useState(false), isArrowsRequired = _f[0], setArrowsRequired = _f[1];
    var _g = useState(0), maxIterations = _g[0], setMaxIterations = _g[1];
    var _h = useState(0), numberOfClicks = _h[0], updateNumberOfClicks = _h[1];
    var _j = useState(30), scrollableWidth = _j[0], setScrollableWidth = _j[1];
    var _k = useState('left'), scrollDirection = _k[0], updateDirection = _k[1];
    var _l = useState([]), elementsWidth = _l[0], updateElementsWidth = _l[1];
    var scrollContainerRef = React.useRef(null);
    var mainRef = useRef(null);
    var width = useWindowSize()[0];
    // console.log(width);
    var selectedItem = function (index) {
        updateListNumber(index);
    };
    // const scrollHandler = (e: any) => {
    //   const target = e.target;
    //   // console.log(target);
    //   const { scrollLeft, scrollWidth, clientWidth } = target;
    //   const width = scrollWidth - clientWidth;
    //   if (scrollableWidth == 30) {
    //     setScrollableWidth(width);
    //   }
    //   if (scrollLeft == 0) {
    //     mainRef?.current
    //       ?.getElementsByClassName('carousel__button-left1')[0]
    //       ?.setAttribute('style', 'display:none;');
    //   } else {
    //     mainRef?.current
    //       ?.getElementsByClassName('carousel__button-left1')[0]
    //       ?.setAttribute(
    //         'style',
    //         'display:block;margin: 0px 0px 0px 24px;width: 40px;left:0px;z-index:1',
    //       );
    //   }
    //   if (scrollLeft >= scrollableWidth - 10) {
    //     // carousel__button-right1
    //     mainRef?.current
    //       ?.getElementsByClassName('carousel__button-right1')[0]
    //       ?.setAttribute('style', 'display:none;');
    //     console.log('end of scroll');
    //   } else {
    //     mainRef?.current
    //       ?.getElementsByClassName('carousel__button-right1')[0]
    //       ?.setAttribute(
    //         'style',
    //         'display:block;margin: 0px 0px 0px 20px;width: 40px;right:0px;z-index:1',
    //       );
    //   }
    //   console.log(scrollLeft, scrollWidth, clientWidth, width);
    //   setScrolledBy((scrollLeft / width) * 100);
    // };
    var scrollHandler = function (e) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var target = e.target;
        // console.log(target);
        var scrollLeft = target.scrollLeft, scrollWidth = target.scrollWidth, clientWidth = target.clientWidth;
        var width = scrollWidth - clientWidth;
        if (scrollableWidth == 30) {
            setScrollableWidth(width);
        }
        if (scrollLeft == 0) {
            (_b = (_a = mainRef === null || mainRef === void 0 ? void 0 : mainRef.current) === null || _a === void 0 ? void 0 : _a.getElementsByClassName('carousel__button-left1')[0]) === null || _b === void 0 ? void 0 : _b.setAttribute('style', 'display:none;');
        }
        else {
            (_d = (_c = mainRef === null || mainRef === void 0 ? void 0 : mainRef.current) === null || _c === void 0 ? void 0 : _c.getElementsByClassName('carousel__button-left1')[0]) === null || _d === void 0 ? void 0 : _d.setAttribute('style', 'display:block;margin: 0px 0px 0px 24px;width: 40px;left:0px;z-index:1');
        }
        if (scrollLeft >= scrollableWidth - 10) {
            // carousel__button-right1
            (_f = (_e = mainRef === null || mainRef === void 0 ? void 0 : mainRef.current) === null || _e === void 0 ? void 0 : _e.getElementsByClassName('carousel__button-right1')[0]) === null || _f === void 0 ? void 0 : _f.setAttribute('style', 'display:none;');
            // console.log('end of scroll');
        }
        else {
            (_h = (_g = mainRef === null || mainRef === void 0 ? void 0 : mainRef.current) === null || _g === void 0 ? void 0 : _g.getElementsByClassName('carousel__button-right1')[0]) === null || _h === void 0 ? void 0 : _h.setAttribute('style', 'display:block;margin: 0px 0px 0px 20px;width: 40px;right:0px;z-index:1');
        }
    };
    useEffect(function () {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.scrollContainer',
                start: 'top center',
            },
        });
        tl.to(['.twocards_title', '.twocards_cards'], {
            autoAlpha: 1,
            duration: 1,
            stagger: 0.5,
        });
    }, []);
    useEffect(function () {
        if (data.data.length > 1) {
            setTimeout(function () {
                var container = Array.from(scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.current.getElementsByClassName('hover-list-tab'));
                // console.log(
                //   container,
                //   'container',
                //   scrollContainerRef?.current.offsetWidth,
                // );
                if (container[0] !== undefined) {
                    var totalElementsWidth_1 = 0;
                    container.map(function (item, index) {
                        totalElementsWidth_1 = totalElementsWidth_1 + item.offsetWidth + 32;
                    });
                    // console.log(totalElementsWidth, 'totalElementsWidth');
                    if ((scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.current.offsetWidth) <
                        totalElementsWidth_1 - 40) {
                        setArrowsRequired(true);
                    }
                    var iteration = 0;
                    var count = 0;
                    for (var i = 0; i < container.length; i++) {
                        iteration = iteration + container[i].offsetWidth + 32;
                        if (iteration <= (scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.current.offsetWidth)) {
                            count++;
                        }
                        else {
                            break;
                        }
                    }
                    // console.log(
                    //   count,
                    //   container.length,
                    //   container.length - count,
                    //   'count',
                    // );
                    setMaxIterations(container.length - count);
                }
            }, 100);
        }
    }, []);
    useEffect(function () {
        if (activeIndex >= 0 && data.data.length > 1) {
            // const scrollWidth = scrollContainerRef.current.scrollWidth;
            var containerWidth = scrollContainerRef.current.offsetWidth;
            var scrollWidth = scrollContainerRef.current.scrollWidth;
            var maxScroll = scrollWidth - containerWidth;
            var scrollAmount = Math.min(scrollWidth * 0.1, maxScroll);
            // console.log(
            //   containerWidth,
            //   scrollWidth,
            //   maxScroll,
            //   scrollAmount,
            //   gsap.getProperty(scrollContainerRef.current, 'x'),
            //   'sa',
            // );
            gsap.to(scrollContainerRef.current, {
                scrollTo: {
                    // x: `#card-${activeIndex}`,
                    // x: `+=${scrollAmount}`,
                    // x: `${scrollDirection == 'right' ? `+=${scrollAmount}` : `-=${scrollAmount}`}`,
                    // x: `${scrollDirection == 'right' ? `+=200` : `-=200`}`,//activeScrollPosition
                    x: "" + (scrollDirection == 'right'
                        ? activeScrollPosition + " "
                        : "" + activeScrollPosition),
                    // x: scrollWidth,
                    offsetX: 50, // adjust the offset as needed
                },
                duration: 0.5,
                ease: 'power2.inOut', // adjust the easing as needed
            });
        }
    }, [activeIndex, activeScrollPosition]);
    useEffect(function () {
        if (data.data.length > 1) {
            setTimeout(function () {
                // console.log(
                //   scrollContainerRef?.current,
                //   'scrollContainerRef?.current',
                //   scrollContainerRef?.current.offsetWidth,
                // );
                var _a = scrollContainerRef.current, scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
                // console.log(
                //   scrollLeft,
                //   scrollWidth,
                //   clientWidth,
                //   scrollWidth - clientWidth,
                // );
            }, 500);
        }
    }, [numberOfClicks]);
    // const handleScrollClick = (direction: any) => {
    //   // if(maxIterations>numberOfClicks){
    //   // if (
    //   //   (direction == 'right' && scrollableWidth - 10 > scrollLeft) ||
    //   //   (direction == 'left' && scrollLeft > 0)
    //   // ) {
    //   console.log('entered');
    //   updateActiveIndex(direction == 'right' ? activeIndex + 1 : activeIndex - 1);
    //   updateNumberOfClicks(
    //     direction == 'right' ? numberOfClicks + 1 : numberOfClicks - 1,
    //   );
    // };
    var handleScrollClick = function (direction) {
        var _a = scrollContainerRef.current, scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
        // console.log(scrollLeft);
        // console.log('entered');
        // updateActiveIndex(direction == 'right' ? activeIndex + 1 : activeIndex - 1);
        var scrollLeftWidth = 0;
        for (var i = 0; i < elementsWidth.length; i++) {
            scrollLeftWidth += elementsWidth[i];
            if (scrollLeft < scrollLeftWidth) {
                // console.log(i);
            }
        }
        updateActiveScrollPosition(direction == 'right'
            ? activeScrollPosition + 250 < scrollWidth - clientWidth
                ? activeScrollPosition + 250
                : activeScrollPosition + scrollWidth - clientWidth - scrollLeft
            : activeScrollPosition - 250 > 0
                ? activeScrollPosition - 250
                : 0);
        updateNumberOfClicks(direction == 'right' ? numberOfClicks + 1 : numberOfClicks - 1);
        updateDirection(direction);
    };
    return (_jsxs("div", __assign({ className: "w-100vw flex flex-col md:items-center snap-start scrollContainer ", ref: mainRef }, { children: [data.data.length > 1 && (_jsxs("div", __assign({ className: "flex w-full flex-col pt-[42px] md:pt-[31px] " + 'single-items' + " " }, { children: [isArrowsRequired && width >= 1024 && (_jsx("div", __assign({ className: "flex absolute", style: {
                            right: '156px',
                            backgroundColor: 'white',
                            width: "124px",
                        } }, { children: _jsxs("div", __assign({ className: "relative", style: { width: "100%" } }, { children: [_jsx("button", __assign({ tabIndex: 0, "aria-label": "Go to Before card", className: "carousel__button-controller carousel__button--left carousel__button-left1 rounded-full border border-blue absolute", "aria-labelledby": "cc-arrow-icon", onClick: function () { return handleScrollClick('left'); }, style: {
                                        margin: '0px 0px 0px 24px',
                                        width: '40px',
                                        left: '0px',
                                        zIndex: '1',
                                    } }, { children: _jsxs("svg", __assign({ className: "button-controller__icon h-10 transform   rotate-0 ", viewBox: "0 0 40 41", stroke: "#0074bd", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("circle", { cx: "20", cy: "20", r: "19.5", transform: "matrix(-1 0 0 1 40 0)", stroke: "#0074bd" }, void 0),
                                            _jsx("path", { d: "m22.306 15.16-5.384 5.384 5.384 5.384", fill: "none" }, void 0)] }), void 0) }), void 0),
                                _jsx("button", __assign({ tabIndex: 0, "aria-label": "Go to card", className: "carousel__button-controller carousel__button--right carousel__button-right1 rounded-full border border-blue absolute", "aria-labelledby": "cc-arrow-icon", onClick: function () { return handleScrollClick('right'); }, style: {
                                        margin: '0px 0px 0px 20px',
                                        width: '40px',
                                        right: '0px',
                                    } }, { children: _jsxs("svg", __assign({ className: "button-controller__icon h-10 transform   rotate-180 ", viewBox: "0 0 40 41", stroke: "#0074bd", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("circle", { cx: "20", cy: "20", r: "19.5", transform: "matrix(-1 0 0 1 40 0)", stroke: "#0074bd" }, void 0),
                                            _jsx("path", { d: "m22.306 15.16-5.384 5.384 5.384 5.384", fill: "none" }, void 0)] }), void 0) }), void 0),
                                _jsx("div", __assign({ className: "  rounded-full border border-blue absolute", style: {
                                        margin: '0px 0px 0px 24px',
                                        width: '40px',
                                        left: '0px',
                                        zIndex: '0',
                                        opacity: '0.3',
                                    } }, { children: _jsxs("svg", __assign({ className: "button-controller__icon h-10 transform   rotate-0 ", viewBox: "0 0 40 41", stroke: "#0074bd", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("circle", { cx: "20", cy: "20", r: "19.5", transform: "matrix(-1 0 0 1 40 0)", stroke: "#0074bd" }, void 0),
                                            _jsx("path", { d: "m22.306 15.16-5.384 5.384 5.384 5.384", fill: "none" }, void 0)] }), void 0) }), void 0),
                                _jsx("div", __assign({ className: " rounded-full border border-blue absolute", style: {
                                        margin: '0px 0px 0px 20px',
                                        width: '40px',
                                        right: '0px',
                                        opacity: '0.3',
                                    } }, { children: _jsxs("svg", __assign({ className: "button-controller__icon h-10 transform   rotate-180 ", viewBox: "0 0 40 41", stroke: "#0074bd", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("circle", { cx: "20", cy: "20", r: "19.5", transform: "matrix(-1 0 0 1 40 0)", stroke: "#0074bd" }, void 0),
                                            _jsx("path", { d: "m22.306 15.16-5.384 5.384 5.384 5.384", fill: "none" }, void 0)] }), void 0) }), void 0)] }), void 0) }), void 0)),
                    _jsx("div", __assign({ className: "flex snap-x snap-mandatory overflow-x-auto px-[24px] md:w-full  md:px-0 twocards_cards slider-padding", onScroll: scrollHandler, ref: scrollContainerRef, style: {
                            visibility: 'hidden',
                            paddingBottom: '0px !important',
                            overflowX: 'scroll',
                        } }, { children: data.data.map(function (item, i) { return (_jsx("div", __assign({ style: { width: 'max-content', color: '#343741' }, className: "hover-list-tab flex-shrink-0", onClick: function () { return selectedItem(i); } }, { children: _jsx("p", __assign({ id: "card-" + i, className: "highlighted-tab " + (i == listNumber ? 'tab-selected' : ''), style: { paddingBottom: '16px' } }, { children: item.listText }), void 0) }), "card-" + i)); }) }), void 0)] }), void 0)),
            data.data.length > 1 && (_jsx("div", __assign({ className: " w-full " }, { children: _jsx("hr", { className: "mx-[24px] md:mx-[45px] md:block ", style: {
                        borderTop: 'solid 1px #d8dcdb',
                        paddingBottom: "" + (window.innerWidth >= 768
                            ? '64px '
                            : window.innerWidth < 768
                                ? '36px'
                                : ''),
                        margin: "" + (window.innerWidth >= 1024
                            ? '0px 156px '
                            : window.innerWidth >= 768
                                ? '0px 92px'
                                : '0px 24px'),
                    } }, void 0) }), void 0)),
            _jsx(HoverListWithTab, { data: data.data[listNumber] }, "no-animation")] }), void 0));
};
TwoCards.defaultProps = defaultProps;
